import { useState } from "react";
import { TURNSTILE_SITE_KEY } from "../components/Turnstile";

/**
 * Captcha state for a signup form. `widgetKey` goes on the Turnstile widget as its key, so
 * `reset` remounts it and the next submit gets a fresh token (each token is single-use).
 */
const useCaptcha = () => {
    const [token, setToken] = useState<string | null>(null);
    const [widgetKey, setWidgetKey] = useState(0);

    const isMissing = Boolean(TURNSTILE_SITE_KEY) && !token;

    const reset = () => {
        setToken(null);
        setWidgetKey((key) => key + 1);
    };

    return { token, setToken, widgetKey, isMissing, reset };
};

export default useCaptcha;
